import React, { useEffect, useState, useMemo, useCallback, useRef } from 'react';
import { Button, Paper, TextField, Autocomplete, Box, Stack,TableContainer } from '@mui/material';
import { AgGridReact } from 'ag-grid-react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, BarChart, Bar, LabelList } from 'recharts';
import { ModuleRegistry, AllCommunityModule, themeQuartz } from 'ag-grid-community';
import { useGetOutletComboMutation, useGetLaunchingComboMutation, useGetSaleReportsMutation } from '../../services/reports';
import { useGetOutletsMutation } from '../../services/replenishmentSystem';
import LoadingPage from '../loadingPage';
import AlertSnackbar from '../alertSnackbar';
import "react-day-picker/style.css";
import moment from 'moment';
import XLSX from 'xlsx-js-style';//import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import DateRange from '../tools/daterange';
import CustomTable from '../tools/customTable';
const API_URI = process.env.REACT_APP_API_URI;

export default function WeeklyReport() {
  const [getOutlets, outletsResult] = useGetOutletsMutation();
  const [getLaunchingCombo, launchingResult] = useGetLaunchingComboMutation();
  const [getSaleReports, saleReportsResult] = useGetSaleReportsMutation();
  const [dataLoaded, setDataLoaded] = useState([]);
  const [dataTriumph, setDataTriumph] = useState([]);
  const [dataSloggi, setDataSloggi] = useState([]);
  const [columnsGenerated, setColumnsGenerated] = useState([]);
  const [gridHeight, setGridHeight] = useState(300);
  const [snackContent, setSnackContent] = useState("");
  const [range, setRange] = useState({from: moment().startOf('month'), to: moment()});
  const [reportType, setReportType] = useState(null);
  const [selectedStore, setSelectedStore] = useState({});
  const [userId, setUserId] = useState(0);
  const gridRef = useRef();
  
  ModuleRegistry.registerModules([ AllCommunityModule ]);
	const user = JSON.parse(window.localStorage.getItem('user'));

  useEffect(() => {
    handleGridHeight();

    const uId = JSON.parse(window.localStorage.getItem("user"))?.id;
    setUserId(uId);

    window.addEventListener("resize", handleGridHeight);
    return () => {
      window.removeEventListener("resize", handleGridHeight);
    };
  }, []);

  const handleGridHeight = () =>{
    const divHeader = document.getElementById('divHeader');
    setGridHeight(window.innerHeight - (divHeader?.clientHeight || 0) - 126);
  }

  const onChangeReportType=(record)=>{
    setReportType(record.value);
    setDataLoaded([]);
    setDataTriumph([]);
    setDataSloggi([]);
  }

  const getDataView=async()=>{
    if(!reportType) {setSnackContent("Vui lòng chọn loại report"); return;}
    if(!range) return;
    try{
      const result = await getSaleReports({"ReportID": reportType, "Code": selectedStore.value||0
          , "FromDate": moment(range.from).format('DD-MM-YYYY') , "ToDate": moment(range.to).format('DD-MM-YYYY')
      }).unwrap();

      const dt = JSON.parse(result);
      setDataLoaded(dt);
      setDataTriumph(dt.filter(f=>f.BRAND == 'Triumph'));
      setDataSloggi(dt.filter(f=>f.BRAND == 'Sloggi'));
      const dynamicKeys = dt.length > 0 ? Object.keys(dt[0]) : [];
      const columnsGen = dynamicKeys.map((key) => {
        const sampleValue = dt[0]?.[key];

        const isNumeric = sampleValue !== null && sampleValue !== undefined && sampleValue !== '' && !isNaN(sampleValue);

        return {
          accessorKey: key,
          // Format chữ camelCase thành Chữ Có Khoảng Cách (ví dụ: totalAmount -> Total Amount)
          header: key.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase()),
          cell: (info) => info.getValue(),
          // Nếu là số thì căn phải (right), ngược lại căn trái (left)
          align: isNumeric ? 'right' : 'left',
          isNumeric: isNumeric,
          copyColumn: isNumeric
        };
      });
      setColumnsGenerated(columnsGen);

    } catch (err) {
      setSnackContent("Lỗi kết nối!");
      console.error(err);
    }
  }

  return (
    <div style={{padding: '0 10px'}}>
      { (saleReportsResult.isLoading) && <LoadingPage /> }
      <div style={{marginTop: '10px'}}>
        <Box id='divHeader' sx={{ width: '100%' }}>
          <Stack
            direction="row"
            spacing={1.5}
            alignItems="center"
            sx={{
              overflowX: 'auto', pt: 1, mb: 0.5,
              pb: 0.5, // Space for the scrollbar so it doesn't touch the buttons
              '&::-webkit-scrollbar': {
                height: '6px',
              },
              '&::-webkit-scrollbar-thumb': {
                backgroundColor: '#ccc',
                borderRadius: '10px',
              },
              // Ensure items don't shrink and stay on one line
              flexWrap: 'nowrap',
            }}
          >
            <Autocomplete disablePortal size="small"
              options={[{value: 'WeeklyMessage', label: 'Weekly Message'}, {value: 'WeeklySales', label: 'Weekly Sales'}]}
              sx={{ flexShrink: 0, width: 250 }}
              onChange={(e, item)=>onChangeReportType(item)}
              renderInput={(params) => <TextField {...params} label="Select report" />}
              disableClearable
            />
            <Box sx={{ flexShrink: 0 }}>
              <DateRange range={range} setRange={setRange} />
            </Box>
						
            <Button variant="contained" onClick={getDataView}
              sx={{ flexShrink: 0 }}>View</Button>
          </Stack>
        </Box>
        
        <Box sx={{ width: '100%', display: 'flex', flexDirection: 'row' }}>
          <Box>
            <CustomTable data={dataTriumph} columns={columnsGenerated} showFilter={false} showSearchAllColumn={false} height={gridHeight} />
          </Box>
          <Box sx={{ width: '10px'}}></Box>
          <Box>
            <CustomTable data={dataSloggi} columns={columnsGenerated} showFilter={false} showSearchAllColumn={false} height={gridHeight} />
          </Box>
        </Box>
      </div>

      <AlertSnackbar message={snackContent} setSnackContent={setSnackContent}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }} />
    </div>
  )
}